import { Box, Grid, Typography } from "@material-ui/core";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  getVehicleAction,
  getVehicleBarChart,
  getVehicleComparison,
  getVehicleLevel4TableData,
} from "src/app-redux/hq-dashboard/actions/hqDashboardActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { IDashboard, IDashboardVehicleBar } from "src/common/typings/hq-dashboard";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { useStyles } from "./style";
import { VehicleLevel3ComparisonTable } from "./VehicleLevel3ComparisonTable";
import { VehicleLevel4Table } from "./VehicleLevel4Table";
import {
  allBorderTerminals,
  selectedBorderTerminals,
  selectedEndDate,
  selectedStartDate,
} from "src/app-redux/hq-dashboard/hqDashboardSlice";
import moment from "moment";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

interface Props {}

export function Vehicles({}: Props): React.ReactElement {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const selectedTerminals = useAppSelector(selectedBorderTerminals);
  const startDate = useAppSelector(selectedStartDate);
  const endDate = useAppSelector(selectedEndDate);

  const [showNoDataFound, setShowNoDataFound] = useState<boolean>(false);
  const [showNoBarDataFound, setShowNoBarDataFound] = useState<boolean>(true);
  const [showDetailsBox, setShowDetailsBox] = useState<boolean>(false);
  const [isOpenDailog, setIsOpenDailog] = useState(false);
  const [isOpenLevel4Dailog, setIsOpenLevel4Dailog] = useState(false);

  const [pieChartList, setpieChartList] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [barChartList, setbarChartList] = useState<any>([]);
  const pieChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  const [data, setData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  });
  const [colors, setColors] = useState<any>([]);
  const [barChartData, setBarChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Vehicles",
        data: [],
        backgroundColor: "#FFD500",
        borderRadius: 50,
        barThickness: 10,
      },
    ],
  });
  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    onHover: (event: any, chartElement: any) => {
      event.native.target.style.cursor = chartElement.length ? "pointer" : "default";
    },
    onClick: async (event: any, chartElement: any) => {
      if (chartElement?.length > 0) {
        const index = chartElement[0]?.index;
        setdata2Vehicle({
          type: barChartList[index].vehicleType,
          value: barChartList[index].count,
        });
        await dispatch(
          getVehicleLevel4TableData({
            startDate: startDate,
            endDate: endDate,
            isVehicleType: true,
            type: barChartList[index]?.vehicleType,
            terminalId: selectedTerminals.toString(),
            headerType: barChartHeading,
          })
        );
        toggleLevel4Dialog();
      }
    },
  };
  const [barChartHeading, setBarChartHeading] = useState<string>("");
  const [barChartHeadingValue, setBarChartHeadingValue] = useState<number>(0);
  const allBTs: any = useAppSelector(allBorderTerminals);
  const [data2Vehicle, setdata2Vehicle] = useState<any>({});
  const [selectedBTNames, setSelectedBTNames] = useState<any[]>([]);
  const [selectedVehicle, setSelectedVehicle] = useState<string>("");

  useEffect(() => {
    const arr: string[] = [];
    selectedTerminals.forEach((id: number) => {
      arr.push(allBTs.find((item: any) => item.id == id)?.alias);
      setSelectedBTNames(arr);
    });
  }, [selectedTerminals]);

  useEffect(() => {
    setShowDetailsBox(false);
    setShowNoBarDataFound(true);
    if (startDate && endDate && selectedTerminals.length > 0) {
      setShowNoDataFound(false);
      getInsight(startDate, endDate);
    } else {
      setShowNoDataFound(true);
    }
  }, [startDate, endDate, selectedTerminals]);

  const getNewColorCode: any = () => {
    const colorCode = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
    return colorCode.length == 7 ? colorCode : getNewColorCode();
  };

  const getInsight = async (startDate: string, endDate: string) => {
    const colors: any = [];
    const req: IDashboard = {
      startDate: startDate,
      endDate: endDate,
      terminalId: selectedTerminals.toString(),
    };
    const res = await dispatch(getVehicleAction(req));
    if (res?.payload) {
      if (res.payload.vehicleConsignmentWidgetHQ.length) {
        setShowNoDataFound(false);
        setTotalAmount(
          res.payload.vehicleConsignmentWidgetHQ.reduce(
            (partialSum: any, a: any) => partialSum + a.count,
            0
          )
        );
        setData({
          labels: res.payload.vehicleConsignmentWidgetHQ.map((item: any) => {
            return item.consignmentType;
          }),
          datasets: [
            {
              label: "",
              data: res.payload.vehicleConsignmentWidgetHQ.map((item: any) => {
                return item.count;
              }),
              backgroundColor: res.payload.vehicleConsignmentWidgetHQ.map(() => {
                const colorCode = getNewColorCode();
                colors.push(colorCode);
                return colorCode;
              }),
              borderWidth: 0,
            },
          ],
        });
        setpieChartList(res.payload.vehicleConsignmentWidgetHQ);
        setColors(colors);
        showVehicle(res.payload.vehicleConsignmentWidgetHQ[0]);
      } else {
        setShowNoDataFound(true);
        setTotalAmount(0);
        setData({
          labels: [],
          datasets: [
            {
              label: "",
              data: [],
              backgroundColor: [],
              borderWidth: 0,
            },
          ],
        });
        setpieChartList([]);
        setColors([]);
      }
    }
  };

  const showVehicle = async (vehicleItem: any) => {
    setSelectedVehicle(vehicleItem.consignmentType);
    const req: IDashboardVehicleBar = {
      startDate: startDate,
      endDate: endDate,
      consignmentType: vehicleItem.consignmentType,
      terminalId: selectedTerminals.toString(),
    };
    const res = await dispatch(getVehicleBarChart(req));
    setShowDetailsBox(true);
    if (res?.payload) {
      if (res.payload.vehicleTypeInsightWidget.length) {
        setShowNoBarDataFound(false);
        setbarChartList(res.payload.vehicleTypeInsightWidget);
        setBarChartData({
          labels: res.payload.vehicleTypeInsightWidget.map((item: any) => {
            return item.vehicleType;
          }),

          datasets: [
            {
              label: "Vehicles",
              data: res.payload.vehicleTypeInsightWidget.map((item: any) => {
                return item.count;
              }),
              backgroundColor: "#FFD500",
              borderRadius: 50,
              barThickness: 10,
            },
          ],
        });
        setBarChartHeading(vehicleItem.consignmentType);
        setBarChartHeadingValue(vehicleItem.count);
      } else {
        setShowNoBarDataFound(true);
        setBarChartData({
          labels: [],
          datasets: [
            {
              label: "Vehicles",
              data: [],
              backgroundColor: "#FFD500",
              borderRadius: 50,
              barThickness: 10,
            },
          ],
        });
        setBarChartHeading("");
        setBarChartHeadingValue(0);
      }
    }
  };

  const toggleDialog = async () => {
    setIsOpenDailog(!isOpenDailog);
  };

  const toggleLevel4Dialog = async () => {
    setIsOpenLevel4Dailog(!isOpenLevel4Dailog);
  };

  return (
    <>
      <TransitionDialog
        isOpen={isOpenDailog}
        handleClose={toggleDialog}
        maxWidth="md"
        heading="Comparison"
        isCustomValidate={true}
      >
        <VehicleLevel3ComparisonTable />
      </TransitionDialog>
      <TransitionDialog
        isOpen={isOpenLevel4Dailog}
        handleClose={toggleLevel4Dialog}
        maxWidth="xl"
        isCustomValidate={true}
      >
        <Grid container direction="row" className={classes.level4TableOrangeHead}>
          <Grid item xs={12} md={2}>
            <p className={classes.topDivHeadings}>Selected Period</p>
            <p>
              <b>From</b> : {moment(startDate).format("DD/MM/YYYY hh:mm A")}
            </p>
            <p>
              <b>To</b> : {moment(endDate).format("DD/MM/YYYY hh:mm A")}
            </p>
          </Grid>
          <Grid item xs={12} md={8} style={{ textAlign: "center" }}>
            <p className={classes.topDivHeadings}>Selected BT </p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {selectedBTNames.map((item, index) => {
                return (
                  <p key={index + item} style={{ marginBottom: 0, marginRight: "3px" }}>
                    {item} {index < selectedBTNames.length - 1 ? "," : ""}
                  </p>
                );
              })}
            </div>
          </Grid>
          <Grid item xs={12} md={2}>
            <p className={classes.topDivHeadings} style={{ textAlign: "center" }}>
              Vehicles
            </p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ maxWidth: "50%" }}>{barChartHeading} =</p>
              <p>{barChartHeadingValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}</p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ maxWidth: "50%" }}>{data2Vehicle.type} =</p>
              <p>{data2Vehicle.value}</p>
            </div>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            overflow: "auto",
            // display: showLevel4Table ? "block" : "none",
            maxHeight: "300px",
          }}
        >
          <VehicleLevel4Table />
        </Grid>
      </TransitionDialog>
      {/* Vehicle Section */}
      <Grid container direction="row">
        <Grid
          item
          xs={12}
          className={classes.outer}
          style={{
            display: showNoDataFound ? "flex" : "none",
            justifyContent: "space-around",
            fontSize: "14px",
          }}
        >
          No records found.
        </Grid>
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          style={{ display: showNoDataFound ? "none" : "flex" }}
        >
          {/* Total Vehicles */}
          <Grid item xs={12} lg={showDetailsBox ? 7 : 12} className={classes.outer}>
            {/* Header */}
            <Grid item xs={12} md={7}>
              {/* Total Number */}
              <Grid item xs={12} md={7} container direction="row">
                <Typography className={classes.headingText}>Vehicles: </Typography>
                <Typography className={classes.headingAmount}>
                  {totalAmount.toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction="row">
              {/* List */}
              <Grid
                item
                xs={12}
                md={5}
                lg={showDetailsBox ? 5 : 4}
                xl={showDetailsBox ? 4 : 3}
                className={classes.itemsList}
              >
                {pieChartList.map((item: any) => {
                  return (
                    <Grid
                      container
                      direction="row"
                      key={item.consignmentType}
                      className={
                        selectedVehicle === item.consignmentType
                          ? `${classes.selectedItem} ${classes.item}`
                          : classes.item
                      }
                      onClick={() => showVehicle(item)}
                    >
                      <Grid container direction="row" item xs={7}>
                        <div
                          className="colorPicker"
                          style={{
                            width: "15px",
                            height: "15px",
                            margin: "0 10px 14px 0px",
                            backgroundColor: colors[pieChartList.indexOf(item)],
                          }}
                        ></div>
                        <Box className={classes.label}>{item.consignmentType}</Box>
                      </Grid>
                      <Grid item xs={5} className={classes.labelNumber}>
                        {item.count.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              {/* Pie Chart */}
              <Grid item xs={12} md={6} lg={6} xl={6} className={classes.pieChartDiv}>
                <Box maxWidth={350} maxHeight={350}>
                  <Pie data={data} options={pieChartOptions} />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          {/* Bar Chart No Data */}
          <Grid
            item
            xs={12}
            lg={5}
            style={{
              display: showDetailsBox && showNoBarDataFound ? "block" : "none",
              justifyContent: "space-around",
              fontSize: "14px",
            }}
          >
            <Box
              className={classes.outer}
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "space-around",
                fontSize: "14px",
              }}
              sx={{ marginLeft: { xs: "0", lg: "10px" }, marginTop: { xs: "10px", lg: "0" } }}
            >
              No data found.
            </Box>
          </Grid>
          {/* Bar Chart */}
          <Grid
            item
            xs={12}
            lg={5}
            style={{
              display: showDetailsBox && !showNoBarDataFound ? "block" : "none",
            }}
          >
            <Box
              className={classes.outer}
              style={{ height: "100%" }}
              sx={{ marginLeft: { xs: "0", lg: "10px" }, marginTop: { xs: "10px", lg: "0" } }}
            >
              <Grid item container direction="row">
                <Grid item xs={9} container direction="row">
                  <Typography className={classes.headingText}>{barChartHeading}: </Typography>
                  <Typography className={classes.headingAmount}>
                    {barChartHeadingValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
                  </Typography>
                  <Typography style={{ paddingTop: "8px", paddingLeft: "3px" }}>
                    {barChartHeadingValue == 1 ? "vehicle" : "vehicles"}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      color: "#488cfb",
                      textDecoration: "underline",
                      paddingTop: "7px",
                    }}
                    onClick={async () => {
                      await dispatch(
                        getVehicleComparison({
                          startDate: startDate,
                          endDate: endDate,
                          terminalId: selectedTerminals.toString(),
                        })
                      );
                      toggleDialog();
                    }}
                  >
                    Comparison
                  </Box>
                </Grid>
              </Grid>
              <Grid container direction="row">
                {barChartList.map((item: any) => {
                  return (
                    <Grid
                      container
                      direction="row"
                      item
                      xs={6}
                      key={item.vehicleType}
                      className={classes.barChartItem}
                    >
                      <Grid item xs={7}>
                        {item.vehicleType ? item.vehicleType : "N/A"}:
                      </Grid>
                      <Grid item xs={5} className={classes.barChartItemAmount}>
                        {item.count}
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
              <Bar options={barChartOptions} data={barChartData} />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
